// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__IRYdH","author":"Table_author__3AdLp","authorImage":"Table_authorImage__2-u1V","unreadRow":"Table_unreadRow__3-0KL"};